// extracted by mini-css-extract-plugin
module.exports = {"formFields":"Opportunity_formFields__YLeH2","requiredField":"Opportunity_requiredField__7Gjpv","drawerTitle":"Opportunity_drawerTitle__sX8S9"};